import api from "../api";

export const getProducts = () => {
    return api.get('/dashboard/products/fetch');
}

export const getBrands = () => {
    return api.get('/dashboard/products/brands');
}

interface heroImage {
    id: number;
    brand_hero: File;
}

export const updateProduct = ({id, brand_hero}: heroImage) => {
    const formData = new FormData();
    formData.append('brand_hero', brand_hero);

    return api.post(`/dashboard/products/store/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

interface lifestyleImage {
    id: number;
    lifestyle_image: File;
}

export const updateProductLifestyle = ({id, lifestyle_image}: lifestyleImage) => {
    const formData = new FormData();
    formData.append("brand_lifestyle", lifestyle_image);

    return api.post(`/dashboard/brand-lifestyle/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
